'use client'

import { useEffect } from "react";

export default function GoogleTagManager() {

  useEffect(() => {

      const scriptTag = window.document.createElement("script");
      const noScriptTag = window.document.createElement("noscript");

      scriptTag.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
          j.src='https://wingate.attractiontickets.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-T3CNNF');`;

      noScriptTag.innerHTML = `<iframe src="https://wingate.attractiontickets.com/ns.html?id=GTM-T3CNNF"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

      window.document.head.appendChild(scriptTag);
      window.document.body.prepend(noScriptTag);

      return () => {
        window.document.head.removeChild(scriptTag);
        window.document.body.removeChild(noScriptTag);
      };
  }, []);

  return null
}
